import React from 'react';
import {
	PreLoginInput,
	PreLoginInputPassword,
} from 'views/PreLogin/styled';

export const FIELDS_NAMES = {
    NAME: 'admin_first_name',
    SURNAME: 'admin_last_name',
    EMAIL: 'admin_email',
    PASSWORD: 'admin_password',
    COMPANY_NAME: 'account_name',
    PHONE: 'phone'
}

export const firstStepData = [
    {
        name: FIELDS_NAMES.NAME,
        ruleMsg: 'Name is Required',
        children: () => <PreLoginInput placeholder="NAME" />
    },
    {
        name: FIELDS_NAMES.SURNAME,
        ruleMsg: 'Surname is Required',
        children: () => <PreLoginInput placeholder="SURNAME" />
    },
    {
        name: FIELDS_NAMES.EMAIL,
        ruleMsg: 'Email is Required',
        children: () => <PreLoginInput type="email" placeholder="EMAIL" />
    },
    {
        name: FIELDS_NAMES.PASSWORD,
        ruleMsg: 'Password is Required',
        children: () => <PreLoginInputPassword type="password" placeholder="PASSWORD" />
    },
    {
        name: FIELDS_NAMES.COMPANY_NAME,
        ruleMsg: 'Company name is Required',
        children: () => <PreLoginInput placeholder="COMPANY NAME" />
    },
    {
        name: FIELDS_NAMES.PHONE,
        children: () => <PreLoginInput type="phone" placeholder="PHONE" />
    }
]

export const stepsDetails = [
	{
	  name: "YOUR_DETAILS",
      title: 'YOUR DETAILS'
	},
	{
	  name: "WEBSITE_URL",
      title: 'WEBSITE URL'
	},
	{
	  name: "SCAN_RESULTS",
      title: 'SCAN RESULTS'
	}
  ]